const tileData = [
    {
        img: './assets/frontend/onepage2/img/clients/logo1.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo2.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo3.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo4.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo5.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo6.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo7.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo8.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo9.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo10.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo11.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo12.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo13.png',
        title: 'Image',
        author: 'author',
    },
    {
        img: './assets/frontend/onepage2/img/clients/logo14.png',
        title: 'Image',
        author: 'author',
    },
];

export default tileData;